import { useEffect, useState } from "react";
import StateForm from "./StateForm";

const CreateState = () => {

    const [crumbs] = useState([
        { content: "Home", url: "/" },
        { content: "States", url: "/states" },
        { content: "Add State", url: "/states/create" },
    ]);

    useEffect(() => {
        document.title = 'Create State';

    }, []);

    return (
        <>
            <StateForm crumbs={crumbs} title={"Add State"} btnText={"Add"} />
        </>
    )
}
export default CreateState;